export enum EUserRole {
    ADMIN = 'admin',
    USER = 'user',
    SUPER_ADMIN = 'superAdmin',
    NON_BILLABLE = 'nonBillable',
    ACCOUNT_MANAGER = 'accountManager',
    INVITED = 'invited',
    ACCOUNT_ADMIN = 'accountAdmin',
}
